import type { UnknownAction } from 'redux';
import type { ThunkAction } from 'redux-thunk';

import type { StoreType } from '../reducers';
import type { AppDispatch } from '../store';
import { useAppDispatch } from '../store/hooks';

const useAction = <Args extends unknown[], ReturnVal>(
	action: (...params: Args) => ThunkAction<ReturnVal, StoreType, unknown, UnknownAction>
) => {
	const dispatch = useAppDispatch();

	return (...params: Args) => dispatch(action(...params));
};

export const useSyncAction = <Args extends unknown[], ReturnVal>(
	action: (dispatch: AppDispatch, ...params: Args) => ReturnVal
) => {
	const dispatch = useAppDispatch();

	return (...params: Args) => action(dispatch, ...params);
};

export const useNonThunkAction = <Args extends unknown[]>(
	action: (...params: Args) => UnknownAction
) => {
	const dispatch = useAppDispatch();

	return (...params: Args) => dispatch(action(...params));
};

export default useAction;
